(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const observers = new Map();
  const revealSelectors = [
    '.ovrium-capability-bar__item',
    '.op__head > div > span',
    '.op__head > div > h2',
    '.op__head > p',
    '.op__head > a',
    '.op__category',
    '.op__product',
    '.op__notice',
    '.oss__image',
    '.oss__copy > span',
    '.oss__copy > h2',
    '.oss__benefits article',
    '.oss__supply-inner > span',
    '.oss__supply-inner > h2',
    '.oss__steps article',
    '.osl__inner > header > span',
    '.osl__inner > header > h2',
    '.osl__inner > header > p',
    '.osl__grid article',
    '.ovl__inner > header > span',
    '.ovl__inner > header > h2',
    '.ovl__inner > header > p',
    '.ovl__grid article',
    '.ovl__inner > footer > span',
    '.ovl__inner > footer > a',
    '.ovrium-instagram__head > h2',
    '.ovrium-instagram__head > a',
    '.ovrium-instagram__grid > a',
    '.ovrium-instagram__grid > div',
    '.ovrium-closing__header > span',
    '.ovrium-closing__header > h2',
    '.ovrium-closing__quote',
    '.ovrium-closing__value',
    '.ovrium-closing__cta > *',
  ];

  const visibleImmediately = (element) => {
    element.classList.add('homepage-motion-reveal', 'is-visible');
  };

  const initializeHero = (root) => {
    const hero = root.matches?.('.ovrium-hero') ? root : root.querySelector?.('.ovrium-hero');
    if (!hero) return;

    if (reduceMotion.matches) {
      hero.classList.add('is-homepage-motion-entered');
      return;
    }

    requestAnimationFrame(() => {
      requestAnimationFrame(() => hero.classList.add('is-homepage-motion-entered'));
    });
  };

  const initializeReveals = (root = document) => {
    const elements = Array.from(root.querySelectorAll(revealSelectors.join(',')));
    if (!elements.length) return;

    const groups = new Map();
    elements.forEach((element) => {
      const group =
        element.closest('header, .ovrium-closing__header, .ovrium-closing__cta') ||
        element.parentElement;
      const index = groups.get(group) || 0;
      groups.set(group, index + 1);
      element.classList.add('homepage-motion-reveal');
      element.style.setProperty('--homepage-motion-delay', `${Math.min(index * 85, 340)}ms`);
    });

    if (reduceMotion.matches || !('IntersectionObserver' in window)) {
      elements.forEach(visibleImmediately);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      {
        rootMargin: '0px 0px -8% 0px',
        threshold: 0.08,
      }
    );

    elements.forEach((element) => observer.observe(element));
    observers.set(root, observer);
  };

  const initialize = (root = document) => {
    document.documentElement.classList.add('homepage-motion-ready');
    initializeHero(root);
    initializeReveals(root);
  };

  const destroy = (root) => {
    observers.get(root)?.disconnect();
    observers.delete(root);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => destroy(event.target));
})();
